import { render, staticRenderFns } from "./CustomerManagementViewDetails.vue?vue&type=template&id=542c33bb&scoped=true&"
import script from "./CustomerManagementViewDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagementViewDetails.vue?vue&type=style&index=0&id=542c33bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c33bb",
  null
  
)

export default component.exports